angular
  .module('picmonicng')

  .filter('profileCompletePercentage', [
    function () {
      return function (user) {
        var requiredFields = 8;
        var fieldsCompleted = 0;

        if (user.first_name != '') {
          fieldsCompleted += 1;
        }
        if (user.last_name != '') {
          fieldsCompleted += 1;
        }
        if (user.username != '') {
          fieldsCompleted += 1;
        }
        if (user.email != '') {
          fieldsCompleted += 1;
        }
        if (user.lead != '') {
          fieldsCompleted += 1;
        }
        if (user.role != '') {
          fieldsCompleted += 1;
        }
        if (user.school.id != '') {
          fieldsCompleted += 1;
        }
        if (user.graduation_month != '' && user.graduation_year != '') {
          fieldsCompleted += 1;
        }

        return Math.floor((fieldsCompleted / requiredFields) * 100);
      };
    },
  ]);
